import { Briefcase, CheckCircle } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";

const BusinessFormation = () => {
  const mainContent = (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Business Formation Services</h2>
          <p className="text-lg text-muted-foreground mb-12">
            Start your business right with proper legal structure and documentation.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[
              { title: "LLC Formation", items: ["Single-member LLC", "Multi-member LLC", "Operating agreements", "EIN application"] },
              { title: "Corporation Setup", items: ["C-Corporation", "S-Corporation", "Bylaws and articles", "Stock certificates"] },
              { title: "Partnerships", items: ["General partnerships", "Limited partnerships", "Partnership agreements", "Buy-sell agreements"] },
              { title: "Non-Profit", items: ["501(c)(3) formation", "Tax-exempt status", "Board governance", "Compliance"] }
            ].map((service, idx) => (
              <div key={idx} className="bg-card p-8 rounded-lg border border-accent/20">
                <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
                <ul className="space-y-2">
                  {service.items.map((item, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <CheckCircle className="h-5 w-5 text-accent flex-shrink-0 mt-0.5" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );

  return <GenericPracticePage title="Business Formation" subtitle="Establish Your Business with the Right Legal Structure" icon={<Briefcase className="h-16 w-16" />} mainContent={mainContent} />;
};

export default BusinessFormation;